<template>
  <v-card
    class="payment-method"
    :class="{ 'selected': selected }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <v-card-text>
      <div class="payment-method__title">
        {{paymentMethod.name}}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    paymentMethod: {
      required: true,
      type: Object
    },
    selected: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>

.payment-method {
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
  color: black;
  border: 5px solid white;

  &.selected {
    border: 5px solid rgba(0,0,0, 0.25);
  }
  &.disabled {
    cursor: default;
  }
  &__title {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
